module.exports = __webpack_public_path__ + "img/dots-vertical-circle-outline-blk.5a3b7a69.svg";